module.exports = __webpack_public_path__ + "pc/img/img_award2023_01.13a21bf6.png";